import { Car, Plane } from "lucide-react";
import { TESTIMONIOS } from "./data";
import { Reveal, Overline } from "./Reveal";

const ROT = ["lg:-rotate-2", "lg:rotate-1 lg:translate-y-8", "lg:-rotate-1", "lg:rotate-2 lg:translate-y-8"];
const BG = ["bg-white", "bg-sol", "bg-white", "bg-mar text-white"];

const ModeChip = ({ mode, dark }) => {
  const Icon = mode === "avion" ? Plane : Car;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${dark ? "bg-white/15 text-white" : "bg-mar text-white"}`}>
      <Icon className="h-3.5 w-3.5" /> {mode === "avion" ? "En avión" : "En auto"}
    </span>
  );
};

export const Testimonials = () => (
  <section id="testimonios" data-testid="testimonials-section" className="bg-arena py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-16">
      <Reveal>
        <Overline>Nuestros viajeros</Overline>
        <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-[0.95] tracking-tight text-selva sm:text-6xl">
          Volvieron con <span className="font-serif-i font-normal text-barro">saudade.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {TESTIMONIOS.map((t, i) => {
          const dark = i === 3;
          return (
            <Reveal key={t.name} delay={0.1 * i}>
              <figure data-testid={`testimonial-card-${i + 1}`}
                className={`flex h-full min-h-[300px] flex-col justify-between rounded-[2rem] p-7 shadow-[0_30px_60px_-30px_rgba(6,48,31,0.35)] transition-transform duration-500 hover:rotate-0 ${BG[i]} ${ROT[i]}`}>
                <div>
                  {t.mode && <ModeChip mode={t.mode} dark={dark} />}
                  <blockquote className={`mt-6 font-serif-i text-2xl leading-snug ${dark ? "text-white" : "text-selva"}`}>{t.story}</blockquote>
                </div>
                <figcaption className={`mt-8 border-t pt-5 ${dark ? "border-white/20" : "border-selva/15"}`}>
                  <p className={`font-display text-xl font-bold ${dark ? "text-white" : "text-selva"}`}>{t.name}</p>
                  <p className={`text-sm ${dark ? "text-white/80" : "text-tinta/70"}`}>{t.from ? `${t.from} → ` : ""}{t.to}</p>
                </figcaption>
              </figure>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
